module.exports = __webpack_public_path__ + "static/img/account-img.b583966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/account-img.png
// module id = Q9JM
// module chunks = 0